import FollowDealerButton from './FollowDealerButton';

export default FollowDealerButton;
